export const genders = [
  { id: 1, name: "male" },
  { id: 2, name: "female" },
  { id: 3, name: "other" },
];

export const ageRanges = [
  { id: 1, name: "21-30" },
  { id: 2, name: "30-60" },
  { id: 3, name: "60+" },
];

export const heights = [
  { id: 1, name: "short" },
  { id: 2, name: "medium" },
  { id: 3, name: "tall" },
];

export const builds = [
  { id: 1, name: "thin" },
  { id: 2, name: "medium" },
  { id: 3, name: "large" },
];

export const hairs = [
  { id: 1, name: "blonde" },
  { id: 2, name: "brown" },
  { id: 3, name: "black" },
  { id: 4, name: "grey" },
  { id: 5, name: "other" },
];

export const ethnicity = [
  { id: 1, name: "white-british" },
  { id: 2, name: "white-traveller" },
  { id: 3, name: "white-european" },
  { id: 4, name: "black" },
  {
    id: 5,
    name: "asian-indian-pakistani-bangladeshi",
  },
  { id: 6, name: "asian-chinese" },
  { id: 7, name: "arab" },
  { id: 8, name: "other" },
];

export const identityFormOptionsDefaults = {
  ageRanges: ageRanges,
  builds: builds,
  ethnicity: ethnicity,
  genders: genders,
  hair: hairs,
  heights: heights,
};
